import { render, staticRenderFns } from "./VesselViewData.vue?vue&type=template&id=5467586b&scoped=true&"
import script from "./VesselViewData.vue?vue&type=script&lang=js&"
export * from "./VesselViewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467586b",
  null
  
)

export default component.exports